"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AppSchema = exports.APP_TOGGLE_SIDEBAR = undefined;

var _handleActions;

var _constants = require("redux-persist/constants");

var _reduxActions = require("redux-actions");

var _tcomb = require("tcomb");

var t = _interopRequireWildcard(_tcomb);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Define the action constants this reducer handles and exports for its actions
// structure is based on https://github.com/erikras/ducks-modular-redux
var APP_TOGGLE_SIDEBAR = exports.APP_TOGGLE_SIDEBAR = "app/TOGGLE_SIDEBAR";
var AppSchema = exports.AppSchema = t.struct({
    isSidebarToggled: t.Boolean,
    isRehydrationComplete: t.Boolean
}, "AppSchema");
// Define the initial state of this reducer (must conform to the above Schema)
var initialState = AppSchema({ isSidebarToggled: false, isRehydrationComplete: false });
exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, APP_TOGGLE_SIDEBAR, function (state, action) {
    return AppSchema.update(state, {
        isSidebarToggled: {
            $set: !state.isSidebarToggled
        }
    });
}), _defineProperty(_handleActions, _constants.REHYDRATE, function (state, action) {
    try {
        return AppSchema.update(state, {
            isSidebarToggled: {
                $set: action.payload.isSidebarToggled
            },
            isRehydrationComplete: {
                $set: true
            }
        });
    } catch (e) {
        return AppSchema.update(state, {
            isRehydrationComplete: {
                $set: true
            }
        });
    }
}), _handleActions), initialState);


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/app/index.ts
 ** module id = 634
 ** module chunks = 0
 **/